import React, { useEffect, useRef } from 'react';
import { format2ms, ms2format } from '../utils/date';

const Test = () => {
    // let now = Date.now();
    // let a = ms2format(now)
    // let f = '2025-11-03T09:42:06.856307Z';
    // let ms = 1762162926856;
    // let b = format2ms(f);
    // let a = ms2format(b);
    // console.log(a);
    // console.log(b);
    // console.log(f);
    // console.log(a === f);
    // console.log(b === ms);
    // console.log(format2ms(f) == format2ms(ms2format(format2ms(f))))
    // const intervalRef = useRef(null);

    // useEffect(() => {


    //     const generateDataPoint = () => {
    //         const now = new Date();

    //         // Генерация случайного пульса (например, от 60 до 100)
    //         const pulse = Math.floor(Math.random() * 41) + 60;

    //         // Форматирование timestamp с микросекундами
    //         const timestamp =
    //             now.toISOString().slice(0, -1) +
    //             String(now.getMilliseconds()).padStart(3, '0') +
    //             'Z';
    //         console.log({
    //             patient: 0,
    //             pulse,
    //             timestamp,
    //         });
    //         setIndicatorUpdate({
    //             patient: patientId,
    //             pulse,
    //             timestamp,
    //         });
    //     };

    //     // Запускаем генератор каждую секунду
    //     intervalRef.current = setInterval(generateDataPoint, 1000);

    //     // Очистка при размонтировании
    //     return () => {
    //         if (intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //         }
    //     };
    // }, []);

    return <div>Test page</div>;
};

export default Test;

